import angular from 'angular';
import tasksPage from './tasksPage';

export default angular.module('tasks.scenes', [tasksPage]).name;
